(()=>{
  if(window.__sokUnifiedLocalizationReady)return;
  window.__sokUnifiedLocalizationReady=true;

  const selector='[data-sok-localization-switcher]';
  const heavyHandles=new Set([
    'sk48v100n-sok-48v-100ah-lifepo4-battery',
    'sk24v150ph-sok-24v-150ah-lifepo4-battery',
    'sk12v314ph-sok-12v-314ah-lifepo4-battery',
    'sok-batteries-cabinet'
  ]);
  const heavyBlockedCountries=new Set(['CH','GB','NO','IS','HR','LT']);
  let refreshTimer=0;

  const all=()=>Array.from(document.querySelectorAll(selector));
  const source=()=>all()[0]||null;
  const countryCode=()=>source()?.dataset.sokCountryCode||'DE';
  const globallySupported=()=>source()?.dataset.sokCountrySupported==='true';
  const regionTitle=()=>source()?.dataset.sokRegionTitle||'Shipping unavailable to your current region';
  const regionCta=()=>source()?.dataset.sokRegionCta||'Select delivery country';
  const syncBody=()=>document.body.classList.toggle('sok-localization-open',all().some(el=>el.open));

  const handleFromUrl=value=>{
    try{
      const url=new URL(value,window.location.origin);
      const match=url.pathname.match(/\/products\/([^/?#]+)/);
      return match?decodeURIComponent(match[1]):'';
    }catch(_){return ''}
  };

  const currentProductHandle=()=>handleFromUrl(window.location.href);
  const unavailableForRegion=handle=>{
    if(!globallySupported())return true;
    return heavyBlockedCountries.has(countryCode())&&heavyHandles.has(handle);
  };

  const closeDetails=details=>{
    if(!details)return;
    details.removeAttribute('open');
    syncBody();
  };

  const openLocalization=()=>{
    const candidates=all();
    const details=candidates.find(el=>{
      const rect=el.getBoundingClientRect();
      return rect.width>0&&rect.height>0;
    })||candidates[0];
    if(!details)return;
    candidates.forEach(other=>{if(other!==details)other.removeAttribute('open')});
    details.setAttribute('open','');
    syncBody();
    requestAnimationFrame(()=>{
      const panel=details.querySelector('.sok-localization-panel');
      const select=details.querySelector('[data-sok-country-select]');
      if(panel&&select){
        select.focus({preventScroll:true});
        const section=select.closest('.sok-localization-section--country');
        if(section&&typeof section.scrollIntoView==='function')section.scrollIntoView({block:'nearest'});
      }
    });
  };

  const bind=details=>{
    if(!details||details.dataset.sokUnifiedBound==='true')return;
    details.dataset.sokUnifiedBound='true';

    details.addEventListener('toggle',()=>{
      if(details.open)all().forEach(other=>{if(other!==details)other.removeAttribute('open')});
      syncBody();
    });

    details.querySelectorAll('[data-sok-localization-close]').forEach(button=>{
      button.addEventListener('click',event=>{
        event.preventDefault();
        closeDetails(details);
      });
    });

    const countrySelect=details.querySelector('[data-sok-country-select]');
    if(countrySelect){
      countrySelect.addEventListener('change',()=>{
        const form=countrySelect.closest('form');
        if(form){
          if(typeof form.requestSubmit==='function')form.requestSubmit();
          else form.submit();
        }
      });
    }
  };

  const makeMessage=(compact=false)=>{
    const wrap=document.createElement('div');
    wrap.className=compact?'sok-region-card-message':'sok-region-availability';
    wrap.innerHTML=`<div class="${compact?'sok-region-card-message__title':'sok-region-availability__title'}"></div><button type="button" class="${compact?'sok-region-card-message__action':'sok-region-availability__action'}" data-sok-open-country></button>`;
    wrap.querySelector(compact?'.sok-region-card-message__title':'.sok-region-availability__title').textContent=regionTitle();
    const action=wrap.querySelector('[data-sok-open-country]');
    action.textContent=regionCta()+' →';
    action.addEventListener('click',event=>{
      event.preventDefault();
      event.stopPropagation();
      openLocalization();
    });
    return wrap;
  };

  const refreshPdp=()=>{
    const handle=currentProductHandle();
    if(!handle)return;
    const form=document.querySelector('main product-form')||document.querySelector('product-form');
    if(!form)return;
    const unavailable=unavailableForRegion(handle);
    form.classList.toggle('sok-region-market-unavailable',unavailable);
    const existing=form.querySelector(':scope > .sok-region-availability')||form.querySelector('.sok-region-availability');
    if(!unavailable){
      if(existing)existing.remove();
      return;
    }
    if(existing)return;
    const buttons=form.querySelector('.product-form__buttons');
    if(buttons)buttons.before(makeMessage(false));
    else form.appendChild(makeMessage(false));
  };

  const refreshCards=()=>{
    document.querySelectorAll('.card-wrapper.product-card-wrapper').forEach(card=>{
      const link=card.querySelector('a[href*="/products/"]');
      const handle=link?handleFromUrl(link.getAttribute('href')):'';
      if(!handle)return;
      const unavailable=unavailableForRegion(handle);
      card.classList.toggle('sok-region-card-unavailable',unavailable);
      const existing=card.querySelector('.sok-region-card-message');
      if(!unavailable){
        if(existing)existing.remove();
        return;
      }
      if(existing)return;
      const info=card.querySelector('.card-information')||card.querySelector('.card__information')||card;
      info.appendChild(makeMessage(true));
    });
  };

  const refresh=()=>{
    all().forEach(bind);
    refreshPdp();
    refreshCards();
  };

  const queueRefresh=()=>{
    clearTimeout(refreshTimer);
    refreshTimer=window.setTimeout(refresh,80);
  };

  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-sok-open-country]');
    if(trigger){
      event.preventDefault();
      openLocalization();
    }
  });

  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    all().forEach(details=>{if(details.open)closeDetails(details)});
  });

  refresh();
  new MutationObserver(queueRefresh).observe(document.documentElement,{childList:true,subtree:true});
})();
